<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>KIB C - Fase Desktop</b-card-title>
        <b-card-title class="text-primary">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="secondary"
            class="btn-icon"
            size="sm"
            :to="{ name: 'koreksiPengembalian' }"
          >
            <feather-icon icon="ArrowLeftIcon" />
          </b-button>
        </b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col md="6">
            <b-form
              class="needs-validation"
              @submit.prevent="submitCari"
            >
              <b-form-row>
                <b-col
                  md="10"
                  offset-md="1"
                >
                  <b-form-group
                    label="Status"
                    label-for="status"
                  >
                    <b-form-select
                      id="status"
                      v-model="status"
                      :options="dataStatus"
                      @change="changeStatus"
                    />
                  </b-form-group>
                  <b-form-group
                    label="Wilayah"
                    label-for="wilayah"
                  >
                    <b-form-select
                      id="wilayah"
                      v-model="wilayah"
                      :options="dataWilayah"
                      @change="changeWilayah"
                    />
                  </b-form-group>
                  <b-form-group
                    label="PD/UPD"
                    label-for="pdUpd"
                  >
                    <b-overlay
                      :show="isLoadPdUpd"
                      variant="light"
                      opacity="0.85"
                      blur="2px"
                      rounded="sm"
                    >
                      <v-select
                        id="kolok"
                        v-model="pdUpd"
                        label="text"
                        :options="dataPdUpd"
                        @input="inputPdUpd"
                      />
                    </b-overlay>
                  </b-form-group>
                  <b-form-group
                    label="Pencarian"
                    label-for="register"
                  >
                    <b-overlay
                      :show="isLoadRegister"
                      variant="light"
                      opacity="0.85"
                      blur="2px"
                      rounded="sm"
                    >
                      <v-select
                        id="kolok"
                        v-model="register"
                        label="text"
                        :options="dataRegister"
                        @input="inputRegister"
                        @search="searchRegister"
                      />
                    </b-overlay>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-form>
          </b-col>
          <b-col md="6">
            <b-form
              class="needs-validation"
              @submit.prevent="submitForm"
            >
              <b-form-row>
                <b-col
                  md="10"
                  offset-md="1"
                >
                  <b-row>
                    <b-col md="6">
                      <h6 class="font-weight-bolder">
                        Validasi P3B
                      </h6>
                      <b-form-group
                        label="Tanggal Validasi"
                        label-for="tanggalValidasi"
                      >
                        <b-form-input
                          v-model="tanggalValidasi"
                          disabled
                        />
                      </b-form-group>
                      <b-form-group
                        label="Status"
                        label-for="keterangan"
                      >
                        <b-form-input
                          value="Telah divalidasi P3B"
                          disabled
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <h6 class="font-weight-bolder">
                        Koreksi Pelaksana PUA
                      </h6>
                      <b-form-group
                        label="Tanggal Koreksi"
                        label-for="tanggal"
                      >
                        <b-form-input
                          v-model="tanggal"
                          disabled
                        />
                      </b-form-group>
                      <b-form-group
                        label="Catatan"
                        label-for="catatan"
                      >
                        <b-form-textarea
                          id="catatan"
                          v-model="v$.catatan.$model"
                          :state="validateState(v$.catatan)"
                        />
                        <b-form-invalid-feedback
                          v-for="(error, index) of v$.catatan.$errors"
                          :key="index"
                        >
                          <span v-if="error.$validator == 'checkCatatan'">Catatan Harus di Isi Jika Dikembalikan</span>
                          <span v-else>{{ error.$message }}</span>
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-col
                    cols="12"
                    class="text-right pr-0 pt-2"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      :disabled="!isShowForm"
                    >
                      <div v-if="isSubmit">
                        <b-spinner small />
                        <span class="sr-only">Loading...</span>
                      </div>
                      <div v-else>
                        Kembalikan
                      </div>
                    </b-button>
                  </b-col>
                </b-col>
              </b-form-row>
            </b-form>
          </b-col>
        </b-row>
        <b-overlay
          :show="isLoadForm"
          variant="light"
          opacity="0.85"
          blur="2px"
          rounded="sm"
        >
          <b-form
            v-if="isShowForm"
            class="needs-validation"
            @submit.prevent="submitForm"
          >
            <b-form-row>
              <b-col
                md="10"
                offset-md="1"
              >
                <b-form-group
                  label="Status"
                  label-for="status"
                >
                  <b-form-input
                    id="status"
                    v-model="statusValue"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Kode Lokasi"
                  label-for="kodeLokasi"
                >
                  <b-form-input
                    id="kodeLokasi"
                    v-model="kodeLokasi"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="KIB"
                  label-for="kib"
                >
                  <b-form-input
                    id="kib"
                    v-model="kib"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Kode Barang"
                  label-for="kodeBarang"
                >
                  <b-form-input
                    id="kodeBarang"
                    v-model="kodeBarang"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Nama Barang"
                  label-for="namaBarang"
                >
                  <b-form-input
                    id="namaBarang"
                    v-model="nabar"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Kode Register Barang"
                  label-for="kodeRegisterBarang"
                >
                  <b-form-input
                    id="kodeRegisterBarang"
                    v-model="kodeRegisterBarang"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Nilai Perolehan"
                  label-for="nilaiPerolehan"
                >
                  <b-form-input
                    id="nilaiPerolehan"
                    v-model="nilaiPerolehan"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Tanggal Perolehan"
                  label-for="tahunPerolehan"
                >
                  <b-form-input
                    id="tahunPerolehan"
                    v-model="tahunPerolehan"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="1. Kode Barang"
                  label-for="kodeRegisterBarang"
                >
                  <b-form-radio
                    v-model="kesesuaianKodeBarang"
                    value="1"
                    disabled
                  >
                    Sesuai Dengan Data Lama
                  </b-form-radio>
                  <b-form-radio
                    v-model="kesesuaianKodeBarang"
                    value="0"
                    disabled
                  >
                    Tidak Sesuai Dengan Data Lama
                  </b-form-radio>

                  <b-col
                    v-if="kesesuaianKodeBarang === '0'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="KIB Seharusnya"
                      label-for="kibSeharusnya"
                    >
                      <b-form-input
                        v-model="kibSeharusnya"
                        disabled
                      />
                    </b-form-group>

                    <b-form-group
                      label="Kode Barang Yang Seharusnya"
                      label-for="kodeBarangSeharusnya"
                    >
                      <b-form-select
                        id="kodeBarangSeharusnya"
                        v-model="kodeBarangSeharusnya"
                        :options="dataKobar"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                </b-form-group>

                <b-form-group
                  label="2. Ukuran"
                  label-for="ukuran"
                >
                  <b-row>
                    <b-col cols="11">
                      <b-form-input
                        id="ukuran"
                        v-model="ukuran"
                        disabled
                      />
                    </b-col>
                    <b-col cols="1">
                      <label for="satuan">{{ satuan }}</label>
                    </b-col>
                    <b-col
                      cols="11"
                      offset-md="1"
                      class="mt-1"
                    >
                      <b-form-radio
                        v-model="kesesuaianUkuran"
                        value="1"
                        disabled
                      >
                        Sesuai Dengan Data Lama
                      </b-form-radio>
                      <b-form-radio
                        v-model="kesesuaianUkuran"
                        value="0"
                        disabled
                      >
                        Tidak Sesuai Dengan Data Lama
                      </b-form-radio>

                      <b-col
                        v-if="kesesuaianUkuran === '0'"
                        cols="11"
                        offset-md="1"
                        class="mt-1"
                      >
                        <label
                          for="ukuranSeharusnya"
                          class="d-block"
                        >Ukuran Seharusnya
                          <small class="text-warning">Wajib mengacu pada dokumen yang dapat
                            dipertanggungjawabkan</small></label>
                        <b-row>
                          <b-col cols="11">
                            <b-form-input
                              id="ukuranSeharusnya"
                              v-model="ukuranSeharusnya"
                              disabled
                            />
                          </b-col>
                          <b-col cols="1">
                            <label for="satuan">{{ satuanSeharusnya }}</label>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-col>
                  </b-row>
                </b-form-group>

                <b-form-group
                  label="3. Nama Spesifikasi Barang"
                  label-for="namaSpesifikasiBarang"
                >
                  <b-form-input
                    id="namaSpesifikasiBarang"
                    v-model="namaSpesifikasiBarang"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="4. Alamat"
                  label-for="alamat"
                >
                  <b-form-textarea
                    id="alamat"
                    v-model="alamat"
                    disabled
                  />

                  <b-col
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="Provinsi"
                      label-for="provinsi"
                      class="mt-1"
                    >
                      <b-form-select
                        id="provinsi"
                        v-model="provinsi"
                        :options="dataProvinsi"
                        disabled
                      />
                    </b-form-group>

                    <b-form-group
                      label="Kabupaten/Kota"
                      label-for="kabKota"
                      class="mt-1"
                    >
                      <b-form-select
                        id="kabKota"
                        v-model="kabKota"
                        :options="dataKabKota"
                        disabled
                      />
                    </b-form-group>

                    <b-form-group
                      label="Kecamatan"
                      label-for="kecamatan"
                    >
                      <b-form-select
                        id="kecamatan"
                        v-model="kecamatan"
                        :options="dataKecamatan"
                        disabled
                      />
                    </b-form-group>
                    <b-form-group
                      label="Kelurahan"
                      label-for="kelurahan"
                    >
                      <b-form-select
                        id="kelurahan"
                        v-model="kelurahan"
                        :options="dataKelurahan"
                        disabled
                      />
                    </b-form-group>
                    <b-form-group
                      label="Jalan"
                      label-for="jalan"
                    >
                      <b-form-input
                        id="jalan"
                        v-model="jalan"
                        disabled
                      />
                    </b-form-group>
                    <b-row>
                      <b-col cols="2">
                        <b-form-group
                          label="No"
                          label-for="noAlamat"
                        >
                          <b-form-input
                            id="noAlamat"
                            v-model="noAlamat"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="2">
                        <b-form-group
                          label="RT"
                          label-for="rt"
                        >
                          <b-form-input
                            id="rt"
                            v-model="rt"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="2">
                        <b-form-group
                          label="RW"
                          label-for="rw"
                        >
                          <b-form-input
                            id="rw"
                            v-model="rw"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group
                          label="Kode Pos"
                          label-for="kodePos"
                        >
                          <b-form-input
                            id="kodePos"
                            v-model="kodePos"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>

                <b-form-group
                  label="5. Gedung Dan Bangunan Di Atas Tanah Milik"
                  label-for="gedungBangunanTanahMilik"
                >
                  <b-form-select
                    v-model="gedungBangunanTanahMilik"
                    :options="dataGedungBangunanTanahMilik"
                    disabled
                  />
                  <b-col
                    v-if="gedungBangunanTanahMilik === '1'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="PD/UKPD"
                      label-for="gedungBangunanTanahMilikPdUkpd"
                    >
                      <b-form-select
                        v-model="gedungBangunanTanahMilikPdUkpd"
                        :options="dataPdUkpd"
                        disabled
                      />
                    </b-form-group>

                    <b-form-group
                      label="Kode Barang"
                      label-for="gedungBangunanTanahMilikKobar"
                    >
                      <b-form-input
                        id="gedungBangunanTanahMilikKobar"
                        v-model="gedungBangunanTanahMilikKobar"
                        :options="dataGedungBangunanTanahMilikKobar"
                        disabled
                      />
                    </b-form-group>

                    <b-form-group
                      label="Register"
                      label-for="gedungBangunanTanahMilikRegister"
                    >
                      <b-form-input
                        id="gedungBangunanTanahMilikRegister"
                        v-model="gedungBangunanTanahMilikRegister"
                        :options="dataGedungBangunanTanahMilikRegister"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    v-if="
                      gedungBangunanTanahMilik === '2' ||
                        gedungBangunanTanahMilik === '3' ||
                        gedungBangunanTanahMilik === '4'
                    "
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="Sebutkan"
                      label-for="gedungBangunanTanahMilikSebutkan"
                    >
                      <b-form-input
                        id="gedungBangunanTanahMilikSebutkan"
                        v-model="gedungBangunanTanahMilikSebutkan"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                </b-form-group>

                <b-form-group
                  label="6. Indikasi Tercatat Ganda"
                  label-for="isIndikasiGanda"
                >
                  <b-form-radio
                    v-model="isIndikasiGanda"
                    disabled
                    value="1"
                  >
                    Terindikasi Tercatat Ganda Dengan
                  </b-form-radio>
                  <b-col
                    v-if="isIndikasiGanda === '1'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-select
                      id="indikasiGandaDengan"
                      v-model="indikasiGandaDengan"
                      :options="dataIndikasiGandaDengan"
                      disabled
                    />

                    <b-col
                      cols="11"
                      offset-md="1"
                      class="mt-1 pr-0"
                    >
                      <b-form-group
                        v-if="
                          indikasiGandaDengan === '1' ||
                            indikasiGandaDengan === '2'
                        "
                        label="Sebutkan"
                        label-for="indikasiGandaSebutkan"
                      >
                        <b-form-input
                          id="indikasiGandaSebutkan"
                          v-model="indikasiGandaSebutkan"
                          disabled
                        />
                      </b-form-group>

                      <div v-if="indikasiGandaDengan === '3'">
                        <b-form-group
                          label=""
                          label-for="indikasiGandaPdUkpd"
                        >
                          <b-form-select
                            id="indikasiGandaPdUkpd"
                            v-model="indikasiGandaPdUkpd"
                            :options="dataPdUkpd"
                            disabled
                          />
                        </b-form-group>

                        <b-form-group
                          label="Kode Barang"
                          label-for="indikasiGandaKobar"
                        >
                          <b-form-input
                            id="indikasiGandaKobar"
                            v-model="indikasiGandaKobar"
                            disabled
                          />
                        </b-form-group>
                        <b-form-group
                          label="Register"
                          label-for="indikasiGandaRegister"
                        >
                          <b-form-select
                            id="indikasiGandaRegister"
                            v-model="indikasiGandaRegister"
                            :options="dataIndikasiGandaRegister"
                            disabled
                          />
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-col>
                  <b-form-radio
                    v-model="isIndikasiGanda"
                    value="0"
                    disabled
                  >
                    Tidak Tercatat Ganda
                  </b-form-radio>
                </b-form-group>

                <b-form-group
                  label="7. Indikasi Tercatat Gabungan (Gelondongan)"
                  label-for="indikasiGabungan"
                >
                  <b-form-input
                    id="indikasiGabungan"
                    v-model="indikasiGabungan"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="8. SK Penggunaan"
                  label-for="skPenggunaan"
                >
                  <b-form-radio
                    v-model="skPenggunaan"
                    value="1"
                    disabled
                  >
                    Ada SK Penggunaan
                  </b-form-radio>
                  <b-col
                    v-if="skPenggunaan === '1'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="Nomor SK Penggunaan"
                      label-for="nomorSkPenggunaan"
                    >
                      <b-form-input
                        id="nomorSkPenggunaan"
                        v-model="nomorSkPenggunaan"
                        disabled
                      />
                    </b-form-group>
                    <b-form-group
                      label="Tahun SK Penggunaan"
                      label-for="tahunSkPenggunaan"
                    >
                      <b-form-input
                        id="tahunSkPenggunaan"
                        v-model="tahunSkPenggunaan"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                  <b-form-radio
                    v-model="skPenggunaan"
                    disabled
                    value="0"
                  >
                    Tidak Ada SK Penggunaan
                  </b-form-radio>
                </b-form-group>

                <b-form-group
                  label="9. Penggunaan"
                  label-for="penggunaan"
                >
                  <b-form-select
                    id="penggunaan"
                    v-model="penggunaan"
                    :options="dataPenggunaan"
                    disabled
                  />

                  <b-col
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <!-- no. 2 -->
                    <b-form-group
                      v-if="penggunaan === '2'"
                      label="Digunakan Untuk"
                      label-for="digunakanUntuk"
                    >
                      <b-form-input
                        id="digunakanUntuk"
                        v-model="digunakanUntuk[0].value"
                        disabled
                      />
                    </b-form-group>

                    <!-- no. 3 -->
                    <div v-else-if="penggunaan === '3'">
                      <div
                        v-for="(item, index) of pdUkpd"
                        :key="index"
                      >
                        <b-form-group
                          label="PD/UKPD"
                          label-for="pdUkpd"
                        >
                          <b-form-select
                            v-model="item.value"
                            :options="dataPdUkpd"
                            disabled
                          />
                        </b-form-group>

                        <b-col
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <b-form-group
                            label="Digunakan Untuk"
                            label-for="digunakanUntuk"
                          >
                            <b-form-input
                              v-model="digunakanUntuk[index].value"
                              disabled
                            />
                          </b-form-group>
                        </b-col>
                      </div>
                    </div>

                    <!-- no. 4 -->
                    <div v-else-if="penggunaan === '4'">
                      <b-form-checkbox
                        v-model="digunakanBersama"
                        value="1"
                        disabled
                      >
                        PD/UKPD Lain
                      </b-form-checkbox>
                      <b-col
                        v-if="digunakanBersama.includes('1')"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div
                          v-for="(item, index) of pdUkpd"
                          :key="index"
                        >
                          <b-form-group
                            label="PD/UKPD"
                            label-for="pdUkpd"
                          >
                            <b-form-select
                              v-model="item.value"
                              :options="dataPdUkpd"
                              disabled
                            />
                          </b-form-group>
                          <b-col
                            cols="11"
                            offset-md="1"
                            class="mt-1 pr-0"
                          >
                            <b-form-group
                              label="Digunakan Untuk"
                              label-for="digunakanUntuk"
                            >
                              <b-form-input
                                id="digunakanUntuk"
                                v-model="digunakanUntuk[index].value"
                                disabled
                              />
                            </b-form-group>
                          </b-col>
                        </div>
                      </b-col>
                      <b-form-checkbox
                        v-model="digunakanBersama"
                        value="0"
                        disabled
                      >
                        Instansi / Pihak Lain
                      </b-form-checkbox>
                      <b-col
                        v-if="digunakanBersama.includes('0')"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div
                          v-for="(item, indexx) of pemanfaat"
                          :key="indexx + 'i'"
                        >
                          <b-form-group
                            label="Pemanfaat"
                            label-for="pemanfaat"
                          >
                            <b-form-select
                              v-model="item.value"
                              :options="dataPemanfaat"
                              disabled
                            />
                          </b-form-group>
                          <b-col
                            cols="11"
                            offset-md="1"
                            class="mt-1 pr-0"
                          >
                            <div v-if="pemanfaat[indexx].value === '1' || pemanfaat[indexx].value === '2'">
                              <b-form-group
                                label="Nama Pemanfaat"
                                label-for="namaPemanfaat"
                              >
                                <b-form-input
                                  v-model="pemanfaat[indexx].namaPemanfaat"
                                  disabled
                                />
                              </b-form-group>
                              <b-form-group
                                label="Dasar Penggunaan"
                                label-for="dasarPenggunaan"
                              >
                                <b-form-radio
                                  v-model="pemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="1"
                                >
                                  Ada Pinjam Pakai
                                </b-form-radio>
                                <b-form-radio
                                  v-model="pemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="0"
                                >
                                  Tidak Ada Pinjam Pakai
                                </b-form-radio>
                              </b-form-group>
                            </div>

                            <div v-if="pemanfaat[indexx].value === '3'">
                              <b-form-group
                                label="Nama Pemanfaat"
                                label-for="namaPemanfaat"
                              >
                                <b-form-input
                                  v-model="pemanfaat[indexx].namaPemanfaat"
                                  disabled
                                />
                              </b-form-group>
                              <b-form-group
                                label="Dasar Penggunaan"
                                label-for="kodeRegisterBarang"
                              >
                                <b-form-radio
                                  v-model="pemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="1"
                                >
                                  Ada Dasar Penggunaan
                                </b-form-radio>

                                <b-col
                                  v-if="
                                    pemanfaat[indexx].dasarPenggunaan === '1'
                                  "
                                  cols="11"
                                  offset-md="1"
                                >
                                  <b-form-radio
                                    v-model="
                                      pemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="6"
                                  >
                                    Sewa
                                  </b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      pemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="5"
                                  >
                                    Pinjam Pakai
                                  </b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      pemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="3"
                                  >
                                    Bangun Guna Serah
                                  </b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      pemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="4"
                                  >
                                    Bangun Serah Guna
                                  </b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      pemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="7"
                                  >
                                    KSP (Kerjasama Pemanfaatan)
                                  </b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      pemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="1"
                                  >
                                    KSPI
                                  </b-form-radio>
                                </b-col>

                                <b-form-radio
                                  v-model="pemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="0"
                                >
                                  Tidak Ada Dasar Penggunaan
                                </b-form-radio>
                              </b-form-group>
                            </div>
                          </b-col>
                        </div>
                      </b-col>
                    </div>

                    <!-- no. 5 -->
                    <div v-else-if="penggunaan === '5'">
                      <div
                        v-for="(item, indexx) of pemanfaat"
                        :key="indexx + 'i'"
                      >
                        <b-form-group
                          label="Pemanfaat"
                          label-for="pemanfaat"
                        >
                          <b-form-select
                            v-model="item.value"
                            :options="dataPemanfaat"
                            disabled
                          />
                        </b-form-group>
                        <b-col
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <div v-if="pemanfaat[indexx].value === '1' || pemanfaat[indexx].value === '2'">
                            <b-form-group
                              label="Nama Pemanfaat"
                              label-for="namaPemanfaat"
                            >
                              <b-form-input
                                v-model="pemanfaat[indexx].namaPemanfaat"
                                disabled
                              />
                            </b-form-group>
                            <b-form-group
                              label="Dasar Penggunaan"
                              label-for="dasarPenggunaan"
                            >
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaan"
                                disabled
                                value="1"
                              >
                                Ada Pinjam Pakai
                              </b-form-radio>
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaan"
                                disabled
                                value="0"
                              >
                                Tidak Ada Pinjam Pakai
                              </b-form-radio>
                            </b-form-group>
                          </div>

                          <div v-if="pemanfaat[indexx].value === '3'">
                            <b-form-group
                              label="Nama Pemanfaat"
                              label-for="namaPemanfaat"
                            >
                              <b-form-input
                                v-model="pemanfaat[indexx].namaPemanfaat"
                                disabled
                              />
                            </b-form-group>
                            <b-form-group
                              label="Dasar Penggunaan"
                              label-for="kodeRegisterBarang"
                            >
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaan"
                                disabled
                                value="1"
                              >
                                Ada Dasar Penggunaan
                              </b-form-radio>

                              <b-col
                                v-if="pemanfaat[indexx].dasarPenggunaan === '1'"
                                cols="11"
                                offset-md="1"
                              >
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="6"
                                >
                                  Sewa
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="5"
                                >
                                  Pinjam Pakai
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="3"
                                >
                                  Bangun Guna Serah
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="4"
                                >
                                  Bangun Serah Guna
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="7"
                                >
                                  KSP (Kerjasama Pemanfaatan)
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="1"
                                >
                                  KSPI
                                </b-form-radio>
                              </b-col>

                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaan"
                                disabled
                                value="0"
                              >
                                Tidak Ada Dasar Penggunaan
                              </b-form-radio>
                            </b-form-group>
                          </div>
                        </b-col>
                      </div>
                    </div>
                  </b-col>
                </b-form-group>

                <b-form-group
                  label="10. Apakah Bangunan Merupakan Bangunan Bertingkat ?"
                  label-for="kodeRegisterBarang"
                >
                  <b-form-radio
                    v-model="isBertingkat"
                    value="0"
                    disabled
                  >
                    Tidak Bertingkat
                  </b-form-radio>
                  <b-form-radio
                    v-model="isBertingkat"
                    value="1"
                    disabled
                  >
                    Ya, Bertingkat
                    <small class="text-warning">Bertingkat 1 Lantai adalah bangunan yang memiliki
                      bangunan 1 tingkat di atas lantai dasar, tidak termasuk
                      rooftop</small>
                  </b-form-radio>

                  <b-col
                    v-if="isBertingkat === '1'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-input
                      id="bertingkatSeharusnya"
                      v-model="bertingkatSeharusnya"
                      disabled
                    />
                  </b-col>
                </b-form-group>

                <b-form-group
                  label="11. Potensi Pemanfaatan"
                  label-for="potensiPemanfaatan"
                >
                  <b-col
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="a. Apakah Terdapat Lantai Yang Tidak Digunakan ?"
                      label-for="isLantaiDigunakan"
                    >
                      <b-form-radio
                        v-model="isLantaiDigunakan"
                        value="1"
                        disabled
                      >
                        Ya
                      </b-form-radio>
                      <b-col
                        v-if="isLantaiDigunakan === '1'"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <b-form-group
                          label="Jumlah Seluruh Lantai"
                          label-for="jumlahSeluruhLantai"
                        >
                          <b-form-input
                            id="jumlahSeluruhLantai"
                            v-model="jumlahSeluruhLantai"
                            disabled
                          />
                        </b-form-group>
                        <b-form-group
                          label="Jumlah Lantai Yang Digunakan"
                          label-for="jumlahLantaiDigunakan"
                        >
                          <b-form-input
                            id="jumlahLantaiDigunakan"
                            v-model="jumlahLantaiDigunakan"
                            disabled
                          />
                        </b-form-group>
                        <b-form-group
                          label="Jumlah Lantai Yang Tidak Digunakan"
                          label-for="jumlahLantaiTidakDigunakan"
                        >
                          <b-form-input
                            id="jumlahLantaiTidakDigunakan"
                            v-model="jumlahLantaiTidakDigunakan"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-form-radio
                        v-model="isLantaiDigunakan"
                        value="0"
                        disabled
                      >
                        Tidak
                      </b-form-radio>
                    </b-form-group>

                    <b-form-group
                      label="b. Atap Beton"
                      label-for="isAtapBeton"
                    >
                      <b-form-radio
                        v-model="isAtapBeton"
                        value="1"
                        disabled
                      >
                        Ada (Memiliki Atap Beton)
                      </b-form-radio>
                      <b-col
                        v-if="isAtapBeton === '1'"
                        cols="11"
                        offset-md="1"
                      >
                        <b-form-radio
                          v-model="isAtapBetonIsDigunakan"
                          value="1"
                          disabled
                        >
                          Digunakan
                        </b-form-radio>
                        <b-col
                          v-if="
                            isAtapBeton === '1' &&
                              isAtapBetonIsDigunakan === '1'
                          "
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <b-form-group
                            label="Digunakan Untuk"
                            label-for="atapBetonDigunakan"
                          >
                            <b-form-input
                              id="atapBetonDigunakan"
                              v-model="atapBetonDigunakan"
                              disabled
                            />
                          </b-form-group>
                        </b-col>
                        <b-form-radio
                          v-model="isAtapBetonIsDigunakan"
                          value="0"
                          disabled
                        >
                          Tidak Digunakan
                        </b-form-radio>
                      </b-col>
                      <b-form-radio
                        v-model="isAtapBeton"
                        value="0"
                        disabled
                      >
                        Tidak Ada Atap Beton
                      </b-form-radio>
                    </b-form-group>

                    <b-form-group
                      label="c. Basement"
                      label-for="isBasement"
                    >
                      <b-form-radio
                        v-model="isBasement"
                        value="1"
                        disabled
                      >
                        Ada (Memiliki Basement)
                      </b-form-radio>
                      <b-col
                        v-if="isBasement === '1'"
                        cols="11"
                        offset-md="1"
                      >
                        <b-form-radio
                          v-model="isBasementIsDigunakan"
                          value="1"
                          disabled
                        >
                          Digunakan
                        </b-form-radio>
                        <b-col
                          v-if="
                            isBasement === '1' && isBasementIsDigunakan === '1'
                          "
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <b-form-group
                            label="Digunakan Untuk"
                            label-for="basementDigunakan"
                          >
                            <b-form-input
                              id="basementDigunakan"
                              v-model="basementDigunakan"
                              disabled
                            />
                          </b-form-group>
                        </b-col>
                        <b-form-radio
                          v-model="isBasementIsDigunakan"
                          value="0"
                          disabled
                        >
                          Tidak Digunakan
                        </b-form-radio>
                      </b-col>
                      <b-form-radio
                        v-model="isBasement"
                        value="0"
                        disabled
                      >
                        Tidak Ada Basement
                      </b-form-radio>
                    </b-form-group>

                    <b-form-group
                      label="d. Halaman / Taman"
                      label-for="isHalamanUtama"
                    >
                      <b-form-radio
                        v-model="isHalamanUtama"
                        value="1"
                        disabled
                      >
                        Ada (Memiliki Halaman / Utama)
                      </b-form-radio>
                      <b-col
                        v-if="isHalamanUtama === '1'"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <b-form-radio
                          v-model="isHalamanUtamaIsDigunakan"
                          value="1"
                          disabled
                        >
                          Digunakan
                        </b-form-radio>
                        <b-col
                          v-if="
                            isHalamanUtama === '1' &&
                              isHalamanUtamaIsDigunakan === '1'
                          "
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <b-form-group
                            label="Digunakan Untuk"
                            label-for="halamanUtamaDigunakan"
                          >
                            <b-form-input
                              id="halamanUtamaDigunakan"
                              v-model="halamanUtamaDigunakan"
                              disabled
                            />
                          </b-form-group>
                        </b-col>
                        <b-form-radio
                          v-model="isHalamanUtamaIsDigunakan"
                          value="0"
                          disabled
                        >
                          Tidak Digunakan
                        </b-form-radio>
                      </b-col>
                      <b-form-radio
                        v-model="isHalamanUtama"
                        value="0"
                        disabled
                      >
                        Tidak Ada Halaman / Utama
                      </b-form-radio>
                    </b-form-group>
                  </b-col>
                </b-form-group>

                <b-form-group
                  label="12. Nilai Strategis BMD"
                  label-for="nilaiStrategisBMD"
                >
                  <b-form-select
                    id="nilaiStrategisBMD"
                    v-model="nilaiStrategisBMD"
                    :options="dataNilaiStrategisBMD"
                    disabled
                  />

                  <b-col
                    v-if="nilaiStrategisBMD === '1'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-checkbox
                      v-model="memilikiNilaiStrategis"
                      value="3"
                      disabled
                    >
                      Lokasi mudah diakses kendaraan roda 4
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="memilikiNilaiStrategis"
                      value="2"
                      disabled
                    >
                      Terdapat lahan parkir yang memadai (tidak pernah kesulitan
                      dalam memarkirkan kendaraan)
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="memilikiNilaiStrategis"
                      value="1"
                      disabled
                    >
                      Lingkungan nyaman, bersih, tidak bising
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="memilikiNilaiStrategis"
                      value="0"
                      disabled
                    >
                      Tersedianya sumber daya (listrik, air dan layanan jaringan
                      internet)
                    </b-form-checkbox>
                  </b-col>
                </b-form-group>

                <b-form-group
                  label="13. Pengamanan Fisik"
                  label-for="nilaiStrategisBMD"
                >
                  <b-form-radio
                    v-model="pengamananFisik"
                    value="1"
                    disabled
                  >
                    Fisik Dikuasai
                  </b-form-radio>
                  <b-col
                    v-if="pengamananFisik === '1'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-radio
                      v-model="fisikDikuasai"
                      value="1"
                      disabled
                    >
                      Fisik dikuasai seluruh oleh Pemerintah Provinsi DKI
                      Jakarta
                    </b-form-radio>
                    <b-form-radio
                      v-model="fisikDikuasai"
                      value="0"
                      disabled
                    >
                      Fisik dikuasai sebagian oleh pihak lain
                    </b-form-radio>
                    <b-col
                      v-if="pengamananFisik === '1' && fisikDikuasai === '0'"
                      cols="11"
                      offset-md="1"
                      class="mt-1 pr-0"
                    >
                      <b-form-group
                        label="Sebutkan"
                        label-for="fisikDikuasaiSebutkan"
                      >
                        <b-form-input
                          id="fisikDikuasaiSebutkan"
                          v-model="fisikDikuasaiSebutkan"
                          disabled
                        />
                      </b-form-group>
                    </b-col>
                  </b-col>
                  <b-form-radio
                    v-model="pengamananFisik"
                    value="0"
                    disabled
                  >
                    Fisik Tidak Dikuasai (dikuasai seluruhnya oleh pihak lain)
                  </b-form-radio>
                  <b-col
                    v-if="pengamananFisik === '0'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="Sebutkan"
                      label-for="fisikTidakDikuasaiSebutkan"
                    >
                      <b-form-input
                        id="fisikTidakDikuasaiSebutkan"
                        v-model="fisikTidakDikuasaiSebutkan"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                </b-form-group>

                <b-form-group
                  label="14. Sengketa Pada Gedung dan Bangunan"
                  label-for="sengketaGedungBangunan"
                >
                  <b-form-radio
                    v-model="sengketaGedungBangunan"
                    value="1"
                    disabled
                  >
                    Ada Sengketa
                  </b-form-radio>
                  <b-form-radio
                    v-model="sengketaGedungBangunan"
                    value="0"
                    disabled
                  >
                    Tidak Ada Sengketa
                  </b-form-radio>
                </b-form-group>

                <b-form-group
                  label="15. Keterangan Aset Bersejarah"
                  label-for="ketAsetBersejarah"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-radio
                    v-model="ketAsetBersejarah"
                    value="1"
                    disabled
                  >
                    Ya, BMD merupakan aset bersejarah
                  </b-form-radio>
                  <b-form-radio
                    v-model="ketAsetBersejarah"
                    value="0"
                    disabled
                  >
                    Tidak, BMD bukan merupakan aset bersejarah
                  </b-form-radio>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-form>
        </b-overlay>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormRow,
  BCol,
  BFormInput,
  BFormInvalidFeedback,
  BCardHeader,
  BCardBody,
  BButton,
  BFormGroup,
  BCardTitle,
  BSpinner,
  BFormSelect,
  BRow,
  BFormTextarea,
} from 'bootstrap-vue'
import { required, helpers } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import { ref, computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import validasiKeberadaan from '@/composables/validasiKeberadaan'
import dataInformasi from '@/composables/dataInformasi'
import { intThousand } from '@/libs/helper'
import master from '@/composables/master'
import cetakDaftarBmd from '@/composables/cetakDaftarBmd'

export default {
  setup(props, context) {
    const g = context.root

    const routeName = ref(g.$route.name)
    const isSubmit = ref(false)

    // form cari
    const wilayah = ref('')
    const pdUpd = ref({ text: '-- Semua --', value: '' })
    const register = ref({ text: '-- Pilih Salah Satu --', value: null })
    const status = ref('semua-pengembalian')

    const dataWilayah = ref([])
    const dataPdUpd = ref([])
    const dataRegister = ref([])
    const dataStatus = ref([
      { value: 'semua-pengembalian', text: '-- Semua --' },
      { value: '7', text: 'Belum Cetak QR' },
      { value: '8', text: 'Belum Scan QR dan Foto' },
      { value: '9', text: 'Selesai Inventarisasi' },
    ])
    const isLoadPdUpd = ref(false)
    const isLoadRegister = ref(false)

    // form name
    const isLoadForm = ref(false)
    const isShowForm = ref(false)
    const statusValue = ref('')
    const kodeLokasi = ref('')
    const kib = ref('')
    const kodeBarang = ref('')
    const namaBarang = ref('')
    const kodeRegisterBarang = ref('')
    const nabar = ref('')
    const nilaiPerolehan = ref('')
    const tahunPerolehan = ref('')
    const satuan = ref('')
    const kesesuaianKodeBarang = ref('')
    const kibSeharusnya = ref('')
    const kodeBarangSeharusnya = ref('')
    const namaBarangSeharusnya = ref('')
    const ukuran = ref('')
    const kesesuaianUkuran = ref('')
    const ukuranSeharusnya = ref('')
    const satuanSeharusnya = ref('')
    const namaSpesifikasiBarang = ref('')
    const caraPerolehanPenerimaan = ref('')
    const isBertingkat = ref('')
    const bertingkatSeharusnya = ref('')
    const jumlahSeluruhLantai = ref('')
    const isLantaiDigunakan = ref('')
    const jumlahLantaiTidakDigunakan = ref('')
    const jumlahLantaiDigunakan = ref('')
    const jenisBeton = ref('')
    const kesesuaianBahan = ref('')
    const bahanSeharusnya = ref('')
    const skPenggunaan = ref('')
    const nomorSkPenggunaan = ref('')
    const tahunSkPenggunaan = ref('')
    const penggunaan = ref(null)
    const digunakanBersama = ref([])
    const digunakanUntuk = ref([])
    const pdUkpd = ref([])
    const pemanfaat = ref([
      {
        value: null,
        namaPemanfaat: '',
        dasarPenggunaan: '',
        dasarPenggunaanTipe: '',
      },
    ])
    const gedungBangunanTanahMilik = ref(null)
    const gedungBangunanTanahMilikPdUkpd = ref(null)
    const gedungBangunanTanahMilikKobar = ref(null)
    const gedungBangunanTanahMilikRegister = ref(null)
    const gedungBangunanTanahMilikSebutkan = ref('')
    const alamat = ref('')
    const kesesuaianAlamat = ref('0')
    const provinsi = ref(null)
    const kabKota = ref(null)
    const kecamatan = ref(null)
    const kelurahan = ref(null)
    const jalan = ref('')
    const noAlamat = ref('')
    const rt = ref('')
    const rw = ref('')
    const kodePos = ref('')
    const isIndikasiGanda = ref('')
    const indikasiGandaDengan = ref(null)
    const indikasiGandaSebutkan = ref('')
    const indikasiGandaPdUkpd = ref(null)
    const indikasiGandaKobar = ref('')
    const indikasiGandaRegister = ref(null)
    const indikasiGabungan = ref(null)
    const isAtapBeton = ref(null)
    const isAtapBetonIsDigunakan = ref(null)
    const atapBetonDigunakan = ref('')
    const isBasement = ref(null)
    const isBasementIsDigunakan = ref(null)
    const basementDigunakan = ref('')
    const isHalamanUtama = ref(null)
    const isHalamanUtamaIsDigunakan = ref(null)
    const halamanUtamaDigunakan = ref('')
    const nilaiStrategisBMD = ref(null)
    const memilikiNilaiStrategis = ref([])
    const pengamananFisik = ref(null)
    const fisikDikuasai = ref(null)
    const fisikDikuasaiSebutkan = ref('')
    const fisikTidakDikuasaiSebutkan = ref(null)
    const sengketaGedungBangunan = ref(null)
    const ketAsetBersejarah = ref(null)

    const tanggal = ref(moment().format('DD-MM-YYYY'))
    const tanggalValidasi = ref('')
    const rekonKode = ref('')
    const rekonTahun = ref('')

    const catatan = ref('')
    const statusPersetujuan = ref(null)

    const dataKodeLokasi = ref([])
    const dataKib = ref([])
    const dataBahanSeharusnya = ref([
      { value: null, text: '-- Pilih Salah Satu --' },
      { value: '0', text: 'Bukan Beton' },
      { value: '1', text: 'Beton' },
      { value: '2', text: 'Campuran' },
    ])
    const dataPenggunaan = ref([
      { value: null, text: '-- Pilih Salah Satu --' },
      { value: '1', text: 'Tidak Digunakan' },
      { value: '2', text: 'Digunakan Sendiri Seluruhnya Oleh PD/UKPD' },
      { value: '3', text: 'Digunakan Seluruhnya Oleh PD/UKPD Lain' },
      {
        value: '4',
        text: 'Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain',
      },
      { value: '5', text: 'Digunakan Instansi/Pihak Lain Seluruhnya' },
    ])
    const dataPdUkpd = ref([])
    const dataPemanfaat = ref([
      { value: null, text: '-- Pilih Salah Satu --' },
      { value: '1', text: 'Pemerintah Pusat' },
      { value: '2', text: 'Pemerintah Daerah Lainnya' },
      { value: '3', text: 'Pihak Lain Selain Pemerintah' },
    ])
    const dataGedungBangunanTanahMilik = ref([
      { value: null, text: '-- Pilih Salah Satu --' },
      { value: '1', text: 'Pemerintah Daerah Provinsi DKI Jakarta' },
      { value: '2', text: 'Pemerintah Pusat' },
      { value: '3', text: 'Pemerintah Daerah Lain' },
      { value: '4', text: 'Pihak Lain' },
    ])
    const dataGedungBangunanTanahMilikRegister = ref([
      { text: '-- Pilih Salah Satu --', value: null },
    ])
    const dataGedungBangunanTanahMilikKobar = ref([
      { text: '-- Pilih Salah Satu --', value: null },
    ])
    const dataProvinsi = ref([{ value: null, text: '-- Pilih Salah Satu --' }])
    const dataKabKota = ref([{ value: null, text: '-- Pilih Salah Satu --' }])
    const dataKecamatan = ref([{ value: null, text: '-- Pilih Salah Satu --' }])
    const dataKelurahan = ref([{ value: null, text: '-- Pilih Salah Satu --' }])
    const dataIndikasiGandaDengan = ref([
      { value: null, text: '-- Pilih Salah Satu --' },
      { value: '1', text: 'Pemerintah Pusat' },
      { value: '2', text: 'Pemerintah Daerah Lain' },
      { value: '3', text: 'PD/UKPD Lain' },
    ])
    const dataIndikasiGandaPdUkpd = ref([])
    const dataIndikasiGandaRegister = ref([
      { text: '-- Pilih Salah Satu --', value: null },
    ])
    const dataKobar = ref([])
    const dataCaraPerolehanPenerimaan = ref([])
    const dataNilaiStrategisBMD = ref([
      { text: '-- Pilih Salah Satu --', value: null },
      { value: '0', text: 'Tidak Memiliki Nilai Strategis' },
      { value: '1', text: 'Memiliki Nilai Strategis' },
    ])

    const isShowUbah = ref(false)

    const getProvinsi = async () => {
      const resProvinsi = await master.getProvinsi(g)
      resProvinsi.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataProvinsi.value = resProvinsi
    }

    const getKabKota = async () => {
      const params = {
        provinsi: provinsi.value,
      }

      const resKota = await master.getKota(g, params)
      resKota.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataKabKota.value = resKota
    }

    const getKecamatan = async () => {
      const params = {
        provinsi: provinsi.value,
        kota: kabKota.value,
      }
      const resKecamatan = await master.getKecamatan(g, params)
      resKecamatan.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataKecamatan.value = resKecamatan
    }

    const getKelurahan = async () => {
      const params = {
        provinsi: provinsi.value,
        kota: kabKota.value,
        kecamatan: kecamatan.value,
      }
      const resKelurahan = await master.getKelurahan(g, params)
      resKelurahan.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataKelurahan.value = resKelurahan
    }

    const getNoReg = async (kibNoReg = '', kobar = '', kolok = '') => {
      const params = {
        kib: kibNoReg,
        tahun_rekon: rekonTahun.value,
        kode_rekon: rekonKode.value,
        kobar,
        kolok,
      }

      let resNoReg = await master.getNoReg(g, params)
      if (resNoReg) {
        if (resNoReg.rows) {
          resNoReg = resNoReg.rows.map(({ noreg_108: noreg108, ALAMAT: alamatVal }) => ({
            text: `${noreg108} :: ${alamatVal}`,
            value: noreg108,
          }))
          resNoReg.unshift({ text: '-- Pilih Salah Satu --', value: null })
        }
      }
      // dataIndikasiGandaRegister.value = resNoReg
      return resNoReg
    }

    const getKobar = async (kobar = '', kolok = null, kibKobar = '') => {
      const params = {
        kib: kibKobar,
        cari: kobar,
        kolok,
        length: 100000,
      }
      let resKobar = await master.getKobar(g, params)

      resKobar = resKobar.rows.map(data => ({
        text: `${data.kode} :: ${data.nama}`,
        value: data.kode,
        nama: data.nama,
        kodeSatuan: data.kodeSatuan,
      }))
      resKobar.unshift({ text: '-- Pilih Salah Satu --', value: null })
      return resKobar
      // dataKobar.value = resKobar
    }

    const getData = async () => {
      const response = await validasiKeberadaan.getBmdDetail(g, {
        id: register.value.value,
        username: g.$cookies.get('username'),
      })
      const { data, code } = response

      if (code == 200) {
        const {
          KOLOK,
          nama_pd_ukpd_siera: namaPdUkpdSiera,
          kib: kibVal,
          kobar_108: kobar108,
          nabar_108: nabar108,
          noreg_108: noreg108,
          HARGA,
          SATUAN,
          TGLOLEH,
          UKURAN,
          BETON,
          ALAMAT,
          rekon_kode: rekonKodeVal,
          rekon_tahun: rekonTahunVal,
          status: statusVal,
          di_validasi_sensus_note: diValidasiSensusNote,
          di_m_kobar: diMKobar,
          di_m_kobar_a: diMKobarA,
          di_m_nabar_a: diMNabarA,
          di_m_ukuran: diMUkuran,
          di_m_ukuran_a: diMUkuranA,
          di_cara_perolehan: diCaraPerolehan,
          di_m_bertingkat: diMBertingkat,
          di_m_bertingkat_a: diMBertingkatA,
          di_m_lantai_tdk: diMLantaiTdk,
          di_m_lantai_tdk_all: diMLantaiTdkAll,
          di_m_lantai_tdk_use: diMLantaiTdkUse,
          di_m_lantai_tdk_not: diMLantaiTdkNot,
          di_m_beton: diMBeton,
          di_m_beton_a: diMBetonA,
          di_m_sk_penggunaan: diMSkPenggunaan,
          di_sk_penggunaan_tahun: diSkPenggunaanTahun,
          di_sk_penggunaan_no: diSkPenggunaanNo,
          di_penggunaan: diPenggunaan,
          penggunaan_pihak_lain: penggunaanPihakLain,
          penggunaan_opd: penggunaanOpd,
          di_gedung_bangunan_diatas_tanah_milik: diGedungBangunanDiatasTanahMilik,
          di_gedung_bangunan_diatas_tanah_milik_sebut: diGedungBangunanDiatasTanahMilikSebut,
          di_m_alamat: diMAlamat,
          di_kd_prop: diKdProp,
          di_kd_rayon: diKdRayon,
          di_kd_kec: diKdKec,
          di_kd_kel: diKdKel,
          di_kodepos: diKodepos,
          di_jalan: diJalan,
          di_no_jalan: diNoJalan,
          di_rt: diRt,
          di_rw: diRw,
          di_indikasi_ganda: diIndikasiGanda,
          di_indikasi_ganda_dengan: diIndikasiGandaDengan,
          di_indikasi_ganda_sebutkan: diIndikasiGandaSebutkan,
          di_indikasi_ganda_opd: diIndikasiGandaOpd,
          di_indikasi_ganda_kobar: diIndikasiGandaKobar,
          di_indikasi_ganda_register: diIndikasiGandaRegister,
          di_m_kobar_kib: diMKobarKib,
          di_gedung_bangunan_diatas_tanah_milik_opd: diGedungBangunanDiatasTanahMilikOpd,
          di_gedung_bangunan_diatas_tanah_milik_kobar: diGedungBangunanDiatasTanahMilikKobar,
          di_gedung_bangunan_diatas_tanah_milik_noreg: diGedungBangunanDiatasTanahMilikNoreg,
          di_nm_spesifikasi_barang: diNmSpesifikasiBarang,
          di_indikasi_gabungan: diIndikasiGabungan,
          di_pp_at_ada: diPpAtAda,
          di_pp_at_ada_digunakan: diPpAtAdaDigunakan,
          di_pp_at_ada_digunakan_oleh: diPpAtAdaDigunakanOleh,
          di_pp_bm_ada: diPpBmAda,
          di_pp_bm_ada_digunakan: diPpBmAdaDigunakan,
          di_pp_bm_ada_digunakan_oleh: diPpBmAdaDigunakanOleh,
          di_pp_ht_ada: diPpHtAda,
          di_pp_ht_ada_digunakan: diPpHtAdaDigunakan,
          di_pp_ht_ada_digunakan_oleh: diPpHtAdaDigunakanOleh,
          di_nilai_stragtegis: diNilaiStragtegis,
          di_nilai_stragtegis_child: diNilaiStragtegisChild,
          di_pengamanan_fisik: diPengamananFisik,
          di_pengamanan_fisik_child: diPengamananFisikChild,
          di_pengamanan_fisik_note: diPengamananFisikNote,
          di_sengketa: diSengketa,
          di_aset_bersejarah: diAsetBersejarah,
          di_validasi_sensus_date: diValidasiSensusDate,
        } = data
        if (statusVal == 7) statusValue.value = 'Belum Cetak QR'
        else if (statusVal == 8) statusValue.value = 'Belum Scan QR dan Foto'
        else if (statusVal == 9) statusValue.value = 'Selesai Inventarisasi'
        else statusValue.value = ''
        kodeLokasi.value = `${KOLOK}::${namaPdUkpdSiera}`
        kib.value = kibVal
        kodeBarang.value = kobar108
        kodeRegisterBarang.value = noreg108
        nabar.value = nabar108
        nilaiPerolehan.value = intThousand(HARGA.toString().replace('.', ','))
        tahunPerolehan.value = TGLOLEH
        satuan.value = SATUAN
        kesesuaianKodeBarang.value = diMKobar
        kibSeharusnya.value = diMKobarKib
        kodeBarangSeharusnya.value = diMKobarA
        namaBarangSeharusnya.value = diMNabarA
        ukuran.value = UKURAN.toString().replace('.', ',')
        kesesuaianUkuran.value = diMUkuran
        ukuranSeharusnya.value = diMUkuranA
        namaSpesifikasiBarang.value = diNmSpesifikasiBarang
        caraPerolehanPenerimaan.value = diCaraPerolehan
        isBertingkat.value = diMBertingkat
        bertingkatSeharusnya.value = diMBertingkatA
        isLantaiDigunakan.value = diMLantaiTdk
        jumlahSeluruhLantai.value = diMLantaiTdkAll
        jumlahLantaiTidakDigunakan.value = diMLantaiTdkNot
        jumlahLantaiDigunakan.value = diMLantaiTdkUse
        jenisBeton.value = BETON
        kesesuaianBahan.value = diMBeton
        bahanSeharusnya.value = diMBetonA
        skPenggunaan.value = diMSkPenggunaan
        nomorSkPenggunaan.value = diSkPenggunaanNo
        tahunSkPenggunaan.value = diSkPenggunaanTahun
        penggunaan.value = diPenggunaan

        if (penggunaanOpd) {
          if (penggunaanOpd.length > 0) {
            digunakanBersama.value.push('1')

            for (let i = 0; i < penggunaanOpd.length; i += 1) {
              const { di_penggunaan_opd, di_penggunaan_untuk } = penggunaanOpd[i]

              pdUkpd.value.push({ value: di_penggunaan_opd })
              digunakanUntuk.value.push({ value: di_penggunaan_untuk })
            }
          }
        }
        if (penggunaanPihakLain) {
          if (penggunaanPihakLain.length > 0) {
            digunakanBersama.value.push('0')

            pemanfaat.value = []
            for (let i = 0; i < penggunaanPihakLain.length; i += 1) {
              const {
                di_penggunaan_pemanfaat,
                di_penggunaan_pemanfaat_nama,
                di_penggunaan_pemanfaat_dasar,
                di_penggunaan_pemanfaat_dasar_type,
              } = penggunaanPihakLain[i]

              pemanfaat.value.push({
                value: di_penggunaan_pemanfaat,
                namaPemanfaat: di_penggunaan_pemanfaat_nama,
                dasarPenggunaan: di_penggunaan_pemanfaat_dasar,
                dasarPenggunaanTipe: di_penggunaan_pemanfaat_dasar_type,
              })
            }
          }
        }
        gedungBangunanTanahMilik.value = diGedungBangunanDiatasTanahMilik
        gedungBangunanTanahMilikPdUkpd.value = diGedungBangunanDiatasTanahMilikOpd
        gedungBangunanTanahMilikKobar.value = diGedungBangunanDiatasTanahMilikKobar
        gedungBangunanTanahMilikRegister.value = diGedungBangunanDiatasTanahMilikNoreg
        gedungBangunanTanahMilikSebutkan.value = diGedungBangunanDiatasTanahMilikSebut
        alamat.value = ALAMAT
        kesesuaianAlamat.value = diMAlamat
        provinsi.value = diKdProp
        kabKota.value = diKdRayon
        kecamatan.value = diKdKec
        kelurahan.value = diKdKel
        jalan.value = diJalan
        noAlamat.value = diNoJalan
        rt.value = diRt
        rw.value = diRw
        kodePos.value = diKodepos
        isIndikasiGanda.value = diIndikasiGanda
        indikasiGandaDengan.value = diIndikasiGandaDengan
        indikasiGandaSebutkan.value = diIndikasiGandaSebutkan
        indikasiGandaPdUkpd.value = diIndikasiGandaOpd
        indikasiGandaKobar.value = diIndikasiGandaKobar
        indikasiGandaRegister.value = diIndikasiGandaRegister
        indikasiGabungan.value = diIndikasiGabungan === '1'
          ? 'Terindikasi Gabungan'
          : 'Tidak Tercatat Gabungan'
        isAtapBeton.value = diPpAtAda
        isAtapBetonIsDigunakan.value = diPpAtAdaDigunakan
        atapBetonDigunakan.value = diPpAtAdaDigunakanOleh
        isBasement.value = diPpBmAda
        isBasementIsDigunakan.value = diPpBmAdaDigunakan
        basementDigunakan.value = diPpBmAdaDigunakanOleh
        isHalamanUtama.value = diPpHtAda
        isHalamanUtamaIsDigunakan.value = diPpHtAdaDigunakan
        halamanUtamaDigunakan.value = diPpHtAdaDigunakanOleh
        nilaiStrategisBMD.value = diNilaiStragtegis
        memilikiNilaiStrategis.value = diNilaiStragtegisChild || []
        pengamananFisik.value = diPengamananFisik
        fisikDikuasai.value = diPengamananFisikChild
        fisikDikuasaiSebutkan.value = diPengamananFisikNote
        fisikTidakDikuasaiSebutkan.value = diPengamananFisikNote
        sengketaGedungBangunan.value = diSengketa
        ketAsetBersejarah.value = diAsetBersejarah

        rekonKode.value = rekonKodeVal
        rekonTahun.value = rekonTahunVal

        if (statusVal == 6) statusPersetujuan.value = '0'
        else if (statusVal >= 7) statusPersetujuan.value = '1'
        else statusPersetujuan.value = null
        catatan.value = diValidasiSensusNote

        getProvinsi()
        getKabKota()
        getKecamatan()
        getKelurahan()
        dataKobar.value = await getKobar(
          '',
          null,
          kibSeharusnya.value ? kibSeharusnya.value : kib.value,
        )

        let index
        if (diMKobarA) {
          index = dataKobar.value.findIndex(item => item.value == diMKobarA)

          satuanSeharusnya.value = index >= 0 ? dataKobar.value[index].kodeSatuan : SATUAN
        } else satuanSeharusnya.value = SATUAN

        dataIndikasiGandaRegister.value = await getNoReg(
          kibSeharusnya.value ? kibSeharusnya.value : kib.value,
          indikasiGandaKobar.value,
          indikasiGandaPdUkpd.value,
        )

        dataGedungBangunanTanahMilikRegister.value = await getNoReg(
          'A',
          diGedungBangunanDiatasTanahMilikKobar ?? null,
          diGedungBangunanDiatasTanahMilikOpd,
        )
        dataGedungBangunanTanahMilikKobar.value = await getKobar(
          '',
          diGedungBangunanDiatasTanahMilikOpd,
          'A',
        )

        if (diValidasiSensusDate) {
          tanggalValidasi.value = moment(
            diValidasiSensusDate,
            'YYYY-MM-DD HH:mm:ss.000',
          ).format('DD-MM-YYYY')
        }
      }

      isShowUbah.value = false
    }

    // validation
    const requiredMsg = 'tidak boleh kosong'
    const $externalResults = ref({})
    const rules = computed(() => ({
      catatan: {
        required: helpers.withMessage(`Catatan ${requiredMsg}`, required),
      },
    }))

    const v$ = useVuelidate(
      rules,
      { catatan },
      { $externalResults, $autoDirty: true },
    )

    const submitForm = async () => {
      isSubmit.value = true
      const isFormCorrect = await v$.value.$validate()
      // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
      // jika error validasi

      if (!isFormCorrect) {
        isSubmit.value = false
        return
      }

      // mapping data
      const data = {
        di_validasi_sensus: '0',
        di_validasi_sensus_note: catatan.value,
        id_emp: g.$cookies.get('username'),
        id: register.value.value,
      }

      await dataInformasi.validasi(g, data, 'koreksiPengembalian', false)
      isShowForm.value = false
      isSubmit.value = false
      register.value = { text: '-- Pilih Salah Satu --', value: null }
      catatan.value = ''
    }

    const getPdUkpd = async () => {
      const params = {
        wilayah: wilayah.value,
      }
      const resPdUkpd = await master.getPdUpd(g, params)
      return resPdUkpd
    }

    const getCaraPerolehan = async () => {
      const resCaraPerolehan = await master.getCaraPerolehan(g)

      resCaraPerolehan.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataCaraPerolehanPenerimaan.value = resCaraPerolehan
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    const changeWilayah = async () => {
      isLoadPdUpd.value = true
      pdUpd.value = { text: '-- Semua --', value: null }
      register.value = { text: '-- Pilih Salah Satu --', value: null }
      const resPdUkpd = await getPdUkpd()
      isLoadPdUpd.value = false
      isShowForm.value = false
      resPdUkpd.unshift({ text: '-- Semua --', value: null })
      dataPdUpd.value = resPdUkpd
    }

    const getPdUpd = async () => {
      const resPdUkpd = await getPdUkpd()
      isLoadPdUpd.value = false
      isShowForm.value = false
      resPdUkpd.unshift({ text: '-- Semua --', value: null })
      dataPdUpd.value = resPdUkpd
    }

    const getRegister = async (search = '') => {
      const params = {
        filter_upd: pdUpd.value.value,
        length: 20,
        start: 0,
        filter_status: status.value,
        username: g.$cookies.get('username'),
        cari: search,
      }
      const resBmd = await cetakDaftarBmd.getBmd(g, params)
      const { code, list } = resBmd

      dataRegister.value = code == 200
        ? list.map(({
          ALAMAT, HARGA, UKU_SAT, guid_aset: guidAset, id,
        }) => ({
          text: `${ALAMAT} :: ${HARGA} :: ${UKU_SAT} :: ${guidAset}`,
          value: id,
        }))
        : []
    }

    const inputPdUpd = async () => {
      isLoadRegister.value = true
      isShowForm.value = false
      register.value = { text: '-- Semua --', value: '' }
      const params = {
        filter_upd: pdUpd.value.value,
        length: 20,
        start: 0,
        filter_status: status.value,
        username: g.$cookies.get('username'),
      }
      const resBmd = await cetakDaftarBmd.getBmd(g, params)
      const { code, list } = resBmd

      dataRegister.value = code == 200
        ? list.map(({
          ALAMAT, HARGA, UKU_SAT, guid_aset: guidAset, id,
        }) => ({
          text: `${ALAMAT} :: ${HARGA} :: ${UKU_SAT} :: ${guidAset}`,
          value: id,
        }))
        : []
      isLoadRegister.value = false
    }

    const searchRegister = async search => {
      if (search) await getRegister(search)
    }

    const inputRegister = async () => {
      if (register.value) {
        isLoadForm.value = true
        isShowForm.value = true
        await getData()
        isLoadForm.value = false
      } else isShowForm.value = false
    }

    const changeStatus = () => {
      isLoadRegister.value = true
      register.value = { text: '-- Semua --', value: null }
      getPdUpd()
      getRegister()
      isLoadRegister.value = false
    }

    const getAllPdUpd = async () => {
      const resPdUkpd = await getPdUkpd()
      resPdUkpd.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataPdUkpd.value = resPdUkpd
      dataIndikasiGandaPdUkpd.value = resPdUkpd
    }

    getAllPdUpd()
    getCaraPerolehan()
    getWilayah()
    getPdUpd()
    getRegister()

    const validateState = item => {
      const { $error } = item
      let result = null
      if ($error) result = false
      return result
    }

    const resetForm = () => {}

    return {
      v$,
      routeName,
      $externalResults,
      isSubmit,
      wilayah,
      pdUpd,
      register,
      status,
      dataRegister,
      dataWilayah,
      dataPdUpd,
      dataStatus,
      isLoadRegister,
      isLoadPdUpd,
      isLoadForm,
      isShowForm,
      statusValue,
      kodeLokasi,
      kib,
      kodeBarang,
      namaBarang,
      satuan,
      kodeRegisterBarang,
      catatan,
      statusPersetujuan,
      nabar,
      nilaiPerolehan,
      tahunPerolehan,
      kesesuaianKodeBarang,
      kibSeharusnya,
      satuanSeharusnya,
      kodeBarangSeharusnya,
      namaBarangSeharusnya,
      ukuran,
      kesesuaianUkuran,
      ukuranSeharusnya,
      namaSpesifikasiBarang,
      caraPerolehanPenerimaan,
      isBertingkat,
      bertingkatSeharusnya,
      isLantaiDigunakan,
      jumlahSeluruhLantai,
      jumlahLantaiTidakDigunakan,
      jumlahLantaiDigunakan,
      jenisBeton,
      kesesuaianBahan,
      bahanSeharusnya,
      skPenggunaan,
      nomorSkPenggunaan,
      tahunSkPenggunaan,
      penggunaan,
      digunakanBersama,
      digunakanUntuk,
      pdUkpd,
      pemanfaat,
      gedungBangunanTanahMilik,
      gedungBangunanTanahMilikPdUkpd,
      gedungBangunanTanahMilikKobar,
      gedungBangunanTanahMilikRegister,
      gedungBangunanTanahMilikSebutkan,
      alamat,
      kesesuaianAlamat,
      provinsi,
      kabKota,
      kecamatan,
      kelurahan,
      jalan,
      noAlamat,
      rt,
      rw,
      kodePos,
      isIndikasiGanda,
      indikasiGandaDengan,
      indikasiGandaSebutkan,
      indikasiGandaPdUkpd,
      indikasiGandaKobar,
      indikasiGandaRegister,
      indikasiGabungan,
      isAtapBeton,
      isAtapBetonIsDigunakan,
      atapBetonDigunakan,
      isBasement,
      isBasementIsDigunakan,
      basementDigunakan,
      isHalamanUtama,
      isHalamanUtamaIsDigunakan,
      halamanUtamaDigunakan,
      nilaiStrategisBMD,
      memilikiNilaiStrategis,
      pengamananFisik,
      fisikDikuasai,
      fisikDikuasaiSebutkan,
      fisikTidakDikuasaiSebutkan,
      sengketaGedungBangunan,
      ketAsetBersejarah,
      tanggal,
      tanggalValidasi,
      dataKodeLokasi,
      dataKib,
      dataBahanSeharusnya,
      dataPenggunaan,
      dataPdUkpd,
      dataIndikasiGandaPdUkpd,
      dataPemanfaat,
      dataGedungBangunanTanahMilik,
      dataGedungBangunanTanahMilikRegister,
      dataProvinsi,
      dataKabKota,
      dataKecamatan,
      dataKelurahan,
      dataGedungBangunanTanahMilikKobar,
      dataIndikasiGandaRegister,
      dataIndikasiGandaDengan,
      dataKobar,
      dataCaraPerolehanPenerimaan,
      dataNilaiStrategisBMD,
      changeWilayah,
      inputPdUpd,
      inputRegister,
      changeStatus,
      searchRegister,
      resetForm,
      validateState,
      submitForm,
    }
  },
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    BCard,
    BForm,
    BFormRow,
    BCol,
    BFormInput,
    BFormInvalidFeedback,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    BCardTitle,
    BSpinner,
    BFormSelect,
    BRow,
    BFormTextarea,
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
